import { render, staticRenderFns } from "./PaymentMethodsAddCard.vue?vue&type=template&id=6d0c49a7&"
import script from "./PaymentMethodsAddCard.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsAddCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports